import { Col, Row } from "antd";
import Affectation_formulaire from "../components/Affecter_projet/Affectation_formulaire";
import Disponibilite_projet from "../components/Affecter_projet/Disponibilite_projet";
import { ProjectsMap } from "../components/Affecter_projet/ProjectsMap";

function AffecterProjetPage() {
  return (
    <>
      <Row gutter={16} style={{ width: "100%", padding: "20px" }}></Row>
      {/* <Row style={{ width: "100%", padding: "20px" }}>
        <ProjectsMap />
      </Row> */}
    </>
  );
}

export default AffecterProjetPage;
